import moment from "moment";
class operators {
    constructor(
        id,
        login,
        name,
        fecAlta,
        fecBaja,
        ws,
        correoE
        ) {
        this.id = id;
        this.login = login;
        this.name = name;
        this.fecAlta = fecAlta ? moment.utc(fecAlta).format('DD-MM-YYYY') : null;
        this.fecBaja = fecBaja ? moment.utc(fecBaja).format('DD-MM-YYYY') : null;
        this.fecAltaInput = fecAlta ;
        this.fecBajaInput = fecBaja ;
        this.ws = ws;
        this.correoE = correoE;
    }
    static fromJson({
            operId,
            login,
            nombre,
            fecAlta,
            fecBaja,
            ws,
            correoE
    }) {
        return new operators(
            operId,
            login,
            nombre,
            fecAlta,
            fecBaja,
            ws,
            correoE
        );
    }
}
export default operators;
